module.exports = __webpack_public_path__ + "img/004.e42785e9.jpg";